import { CommonModule } from '@angular/common';
import {
  Component,
  forwardRef,
  Input
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { EditorComponent } from '@tinymce/tinymce-angular';

// TinyMCE core
import 'tinymce/tinymce';
import 'tinymce/models/dom/model';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';

// Plugins you want
import 'tinymce/plugins/lists';
import 'tinymce/plugins/code';

@Component({
  selector: 'app-rich-text-editor',
  standalone: true,
  imports: [CommonModule, FormsModule, EditorComponent],
  template: `
    <editor
      [id]="id"
      [disabled]="disabled"
      [init]="editorInit"
      [(ngModel)]="internalValue"
      (ngModelChange)="onEditorChange($event)"
      (onBlur)="handleBlur()">
    </editor>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RichTextEditorComponent),
      multi: true
    }
  ]
})
export class RichTextEditorComponent implements ControlValueAccessor {
  @Input() id = `rte-${Math.random().toString(36).slice(2, 9)}`;
  @Input() height = 300;

  internalValue = '';
  disabled = false;

  editorInit: EditorComponent['init'] = {
    menubar: false,
    statusbar: false,
    branding: false,
    height: this.height,
    plugins: 'lists code',
    toolbar: 'bold italic | bullist numlist | code',
    skin_url: 'assets/tinymce/skins/ui/oxide',
    content_css: 'assets/tinymce/skins/content/default/content.css',
    entity_encoding: 'raw'
  };

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string | null): void {
    this.internalValue = value ?? '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onEditorChange(value: string): void {
    this.internalValue = value;
    this.onChange(value);
  }

  handleBlur(): void {
    this.onTouched();
  }
}